// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: '/metas/importar-baseline',
  component: () => import('modules/goals/baselineImportation/Index.vue'),
  children: [
    {
      path: '',
      name: 'BaselineImportation',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            name: 'PainelMetas',
            text: 'Metas'
          },
          {
            name: 'BaselineImportation',
            text: 'Importar Baseline'
          }
        ]
      },
      component: () => import('modules/goals/baselineImportation/BaselineImportation.vue'),
      beforeEnter(to: Object, from: Object, next: Function) {
        if (hasPermission('web.metas.baseline_import')) {
          next();
        } else {
          next('/');
        }
      }
    }
  ]
};
